module.exports = __webpack_public_path__ + "static/media/Stellar Vox Single Headboard - 120 cm_Charcoal.616fb2b2.png";